import BluebirdPromise from 'bluebird';
import { ApiError } from 'app/scripts/network/api-error';
// eslint-disable-next-line no-restricted-imports
import { Batcher } from 'app/scripts/network/rpc/batcher';
import { sendErrorEvent } from '@trello/error-reporting';

export const sendVerificationRequests = ({
  data,
  onApiError,
}: {
  data: (
    | {
        id: string;
        url: string;
      }
    | undefined
  )[];
  onApiError: (idModelInvalid: string) => void;
}) => {
  if (data.length === 0) {
    return BluebirdPromise.resolve();
  }

  const batcher = new Batcher({
    headers: {
      'X-Trello-Operation-Source': 'rpc',
      'X-Trello-Operation-Name': 'verificationRequests',
    },
  });

  data.forEach((item) => {
    if (!item) {
      return;
    }
    const { id, url } = item;
    return batcher
      .request(url)
      .catch(ApiError, () => {
        return onApiError(id);
      })
      .catch(Batcher.BatchFailure, (batchError) => {
        // We'll handle the batch failure once, after the .send() call
      });
  });

  return batcher
    .send()
    .catch(ApiError.NoResponse, ApiError.Timeout, () => {
      // This is a connectivity problem that doesn't need to be reported, we'll just wait
      // for the next poll
    })
    .catch(ApiError.Unauthenticated, () => {
      // The whole request failed because we aren't authenticated anymore, we don't need
      // to report that
    })
    .catch(ApiError, (error: Error) => {
      sendErrorEvent(
        error || new Error(`Batch Failure while sending verification requests`),
        {
          extraData: {
            errorName: error.name,
            verifyData: JSON.stringify(data),
          },
        },
      );
    });
};
